import { useMemo } from "react";
import cn from "clsx";
import CrehanaLogo from "@crehana/icons/logos/Crehana";
import CrehanaForBusiness from "@crehana/icons/logos/CrehanaForBusiness";
import CrehanaMicroDegree from "@crehana/icons/logos/CrehanaMicroDegree";
import CrehanaPremium from "@crehana/icons/logos/CrehanaPremium";
import { colors } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var white = colors.white,
  purple = colors.purple;
var OrganizationLogo = function OrganizationLogo(_ref) {
  var user = _ref.user,
    isDark = _ref.isDark;
  var currentIconColor = isDark ? white : purple;
  var logoType = useMemo(function () {
    if (user) {
      if (user.isB2B) {
        return 'b2b';
      }
      if (user.isActiveDegree) {
        return 'microdegree';
      }
      if (user.isPremium) {
        return 'premium';
      }
    }
    return 'default';
  }, [user]);
  var renderLogo = function renderLogo(logoClassName) {
    if (logoType === 'b2b') {
      var _user$organization, _user$organization$co, _user$organization2;
      if (isDark && user !== null && user !== void 0 && (_user$organization = user.organization) !== null && _user$organization !== void 0 && (_user$organization$co = _user$organization.configuration) !== null && _user$organization$co !== void 0 && _user$organization$co.darkModeLogo) {
        return /*#__PURE__*/_jsx("img", {
          src: user.organization.configuration.darkModeLogo,
          alt: user.organization.name,
          "aria-hidden": true,
          className: cn('h-24', logoClassName)
        });
      }
      if (user !== null && user !== void 0 && (_user$organization2 = user.organization) !== null && _user$organization2 !== void 0 && _user$organization2.logoHeader) {
        return /*#__PURE__*/_jsx("img", {
          src: user.organization.logoHeader,
          alt: user.organization.name,
          "aria-hidden": true,
          className: cn('h-24', logoClassName)
        });
      }
      return /*#__PURE__*/_jsx(CrehanaForBusiness, {
        size: 32,
        "aria-hidden": true,
        color: currentIconColor,
        secondaryColor: currentIconColor,
        className: logoClassName
      });
    }
    if (logoType === 'premium') {
      return /*#__PURE__*/_jsx(CrehanaPremium, {
        size: 32,
        "aria-hidden": true,
        color: currentIconColor,
        secondaryColor: currentIconColor,
        className: logoClassName
      });
    }
    if (logoType === 'microdegree') {
      return /*#__PURE__*/_jsx(CrehanaMicroDegree, {
        size: 24,
        "aria-hidden": true,
        color: currentIconColor,
        secondaryColor: currentIconColor,
        className: logoClassName
      });
    }
    return /*#__PURE__*/_jsx(CrehanaLogo, {
      size: 16,
      "aria-hidden": true,
      color: currentIconColor,
      secondaryColor: currentIconColor,
      className: logoClassName
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: "flex items-center",
    children: renderLogo()
  });
};
export default OrganizationLogo;